// extracted by mini-css-extract-plugin
export default {"root":"OurStoryPage_root__m7fEA"};